<template>
    <div>
        <el-card class="box-card" v-loading="loading">
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
            <div class="title">个人详细信息</div>
            <el-table :data="personalMsg" border stripe class="mt15">
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="sex" label="性别"></el-table-column>
                <el-table-column prop="age" label="年龄"></el-table-column>
                <el-table-column prop="phone" label="手机号码"></el-table-column>
                <el-table-column prop="province" label="省"></el-table-column>
                <el-table-column prop="city" label="市"></el-table-column>
                <el-table-column prop="area" label="区"></el-table-column>
                <el-table-column prop="address" label="常用眼镜地址"></el-table-column>
                <el-table-column prop="jigouname" label="归属机构"></el-table-column>
                <el-table-column prop="firstusertime" label="首次佩戴时间"></el-table-column>
                <el-table-column prop="usestate" label="是否暂停使用"></el-table-column>
                <el-table-column prop="createtime" label="首次绑定时间"></el-table-column>
                <el-table-column prop="registertype" label="注册方式"></el-table-column>
            </el-table>

            <div class="title mt20">头像</div>
            <TencentyunCosUploadImg :propsimageUrl="imageUrl" @change="changeTencentyunCosUploadImg"></TencentyunCosUploadImg>
            <el-button type="primary" @click="clicksaveavatarurl">保存头像</el-button>

            <div class="title mt20">设备信息</div>
            <el-button v-if="SubRule_Customer_BindUnbind && !havemac" type="primary" @click="clickbind">绑定</el-button>
            <el-table :data="deviceInformation" border stripe class="mt15">
                <el-table-column prop="mac" label="MAC地址"></el-table-column>
                <el-table-column prop="BomsnName" label="设备类型"></el-table-column>
                <el-table-column prop="SaletypeName" label="销售类型"></el-table-column>
                <el-table-column prop="cardnumber" label="保修卡号"></el-table-column>
                <el-table-column prop="leftvalue" :label="lefttypename"></el-table-column>
                <el-table-column prop="operation" label="操作">
                  <template v-slot="scope">
                    <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.displayunbind && SubRule_Customer_BindUnbind" @click="clickunbind">解绑</el-button>
                    <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.lefttype == 1 && SubRule_Customer_Delay" @click="clickdelay1">增加分钟</el-button>
                    <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" v-if="scope.row.lefttype == 2 && SubRule_Customer_Delay" @click="clickdelay2">增加天数</el-button>
                  </template>
                </el-table-column>
            </el-table>

            <div class="title mt20" v-if="SubRule_ZongBu">用户绑定记录</div>
            <el-table :data="bindingRecord" border stripe class="mt15" v-if="SubRule_ZongBu">
                <el-table-column prop="BomsnName" label="设备类型"></el-table-column>
                <el-table-column prop="SaletypeName" label="销售类型"></el-table-column>
                <el-table-column prop="Cardnumber" label="保修卡号"></el-table-column>
                <el-table-column prop="Bindstate" label="绑定/解绑"></el-table-column>
                <el-table-column prop="Adminname" label="操作人员"></el-table-column>
                <el-table-column prop="Createtime" label="操作时间"></el-table-column>
            </el-table>

            <div class="title mt20" v-if="SubRule_ZongBu">总延期时长：{{Delaytotalnum}}</div>
            <el-table :data="totalExtensionTime" border stripe class="mt15" v-if="SubRule_ZongBu">
                <el-table-column prop="BomsnName" label="设备类型"></el-table-column>
                <el-table-column prop="SaletypeName" label="销售类型"></el-table-column>
                <el-table-column prop="Cardnumber" label="保修卡号"></el-table-column>
                <el-table-column prop="Delayvalue" label="延期时长"></el-table-column>
                <el-table-column prop="Adminname" label="操作人员"></el-table-column>
                <el-table-column prop="Createtime" label="操作时间"></el-table-column>
            </el-table>

            <div class="title mt20" v-if="SubRule_ZongBu">用户充值记录</div>
            <el-table :data="rechargeRecord" border stripe class="mt15" v-if="SubRule_ZongBu">
                <el-table-column prop="Id" label="ID"></el-table-column>
                <el-table-column prop="Orderid" label="订单号"></el-table-column>
                <el-table-column prop="Taocanname" label="套餐名称"></el-table-column>
                <el-table-column prop="Money" label="订单金额"></el-table-column>
                <el-table-column prop="Createtime" label="创建时间"></el-table-column>
            </el-table>
        </el-card>

        <!-- 绑定设备弹出框 -->
        <el-dialog title="绑定设备" :visible.sync="binddialog" width="30%" :close-on-click-modal="false">
          <el-form :model="bindForm" ref="bindFormRef" label-width="70px">
            <el-form-item label="保修卡号" class="addAdminForm">
              <el-input v-model="bindForm.cardnumber" placeholder="请输入保修卡号"></el-input>
              <el-button type="success" plain @click="apicheckcardnumber">校验</el-button>
              <li>设备机构：{{bindForm.jigouname}}</li>
              <li>设备类型：{{bindForm.bomsnName}}</li>
              <li>销售类型：{{bindForm.saletypeName}}</li>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clicksavebind">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 绑定设备弹出框-->

        <!-- 延期弹出框 -->
        <el-dialog title="延期" :visible.sync="delaydialog" width="30%" :close-on-click-modal="false">
          <el-form :model="delayForm" ref="delayFormRef" label-width="70px">
            <el-form-item :label="addtypename" class="addAdminForm">
              <el-input v-model="delayForm.delaytime" placeholder=""></el-input>
            </el-form-item>
            <el-form-item label="缴费金额" class="addAdminForm">
              <el-input v-model="delayForm.delaymoney" placeholder=""></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="clicksavedelay">保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 延期弹出框-->
    </div>
</template>

<script>
import TencentyunCosUploadImg from '@/components/TencentyunCosUploadImg.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadImg
  },
  data () {
    return {
      loading: false,
      // 个人详细信息
      personalMsg: [
        {
          name: '',
          sex: '',
          age: '',
          phone: '',
          province: '',
          city: '',
          area: '',
          address: '',
          jigouname: '',
          firstusertime: '',
          usestate: '',
          createtime: '',
          registertype: ''
        }
      ],
      // 设备信息
      deviceInformation: [
        {
          mac: '',
          BomsnName: '',
          SaletypeName: '',
          cardnumber: '',
          leftvalue: '',
          lefttype: 0,
          displayunbind: false
        }
      ],
      bindForm: {
        cardnumber: '',
        jigouname: '',
        bomsnName: '',
        saletypeName: ''
      },
      delayForm: {
        delaytime: 0,
        delaymoney: 0
      },
      bindingRecord: [],
      totalExtensionTime: [],
      rechargeRecord: [],
      imageUrl: '',
      lefttypename: '',
      addtypename: '',
      havemac: false,
      SubRule_Customer_BindUnbind: false,
      SubRule_Customer_Delay: false,
      SubRule_ZongBu: false,
      Delaytotalnum: 0,
      binddialog: false,
      delaydialog: false,
      parentdata: null
    }
  },
  mounted () {
    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_Customer_BindUnbind', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_BindUnbind = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_Customer_Delay', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_Customer_Delay = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_ZongBu', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_ZongBu = true
      }
    })
  },
  methods: {
    LoadData (parentdata) {
      this.parentdata = parentdata
      this.apigetcustomerinfo()
    },
    changeTencentyunCosUploadImg (url) {
      this.imageUrl = url
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    clicksaveavatarurl () {
      this.apieditcustomeravatarurl()
    },
    clickbind () {
      this.binddialog = true
      this.bindForm.cardnumber = ''
      this.bindForm.jigouname = ''
      this.bindForm.bomsnName= ''
      this.bindForm.saletypeName= ''
    },
    clickunbind () {
      this.apieditcustomerunbind()
    },
    clickdelay1 () {
      this.addtypename = '增加分钟'
      this.delaydialog = true
    },
    clickdelay2 () {
      this.addtypename = '增加天数'
      this.delaydialog = true
    },
    clicksavebind () {
      this.apieditcustomerbind()
    },
    clicksavedelay () {
      this.apieditcustomerdelay()
    },
    apigetcustomerinfo: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getcustomerinfo, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.personalMsg[0].name = response.data.Name
            that.personalMsg[0].sex = '男'
            if (response.data.Sex == '2') that.personalMsg[0].sex = '女'
            that.personalMsg[0].age = response.data.Age
            that.personalMsg[0].phone = response.data.Phone
            that.personalMsg[0].province = response.data.Province
            that.personalMsg[0].city = response.data.City
            that.personalMsg[0].area = response.data.District
            that.personalMsg[0].address = response.data.Address
            that.personalMsg[0].jigouname = response.data.Jigouname
            that.personalMsg[0].firstusertime = response.data.Firstusertime
            that.personalMsg[0].usestate = '否'
            if (response.data.Usestate == '2') that.personalMsg[0].usestate = '是'
            that.personalMsg[0].createtime = response.data.Createtime
            that.personalMsg[0].registertype = response.data.Registertype
            that.imageUrl = response.data.Avatarurl
            if (response.data.Mac.length > 5) {
              that.deviceInformation[0].mac = response.data.Mac
              that.deviceInformation[0].BomsnName = response.data.BomsnName
              that.deviceInformation[0].SaletypeName = response.data.SaletypeName
              that.deviceInformation[0].cardnumber = response.data.Cardnumber
              that.deviceInformation[0].leftvalue = response.data.Leftvalue
              that.deviceInformation[0].displayunbind = true
              if (response.data.Lefttype == '1') {
                that.deviceInformation[0].lefttype = 1
                that.lefttypename = '剩余分钟'
              }
              if (response.data.Lefttype == '2') {
                that.deviceInformation[0].lefttype = 2
                that.lefttypename = '剩余天数'
              }
              that.havemac = true
            } else {
              that.deviceInformation[0].mac = ''
              that.deviceInformation[0].BomsnName = ''
              that.deviceInformation[0].SaletypeName = ''
              that.deviceInformation[0].cardnumber = ''
              that.deviceInformation[0].leftvalue = ''
              that.deviceInformation[0].displayunbind = false
              that.deviceInformation[0].lefttype = 0
              that.havemac = false
            }
            that.Delaytotalnum = response.data.Delaytotalnum

            that.bindingRecord = []
            response.data.Bindlist.filter((item1, i1) => {
              that.bindingRecord.push({ BomsnName: item1.BomsnName, SaletypeName: item1.SaletypeName,Cardnumber: item1.Cardnumber, Bindstate: item1.Bindstate, Adminname: item1.Adminname, Createtime: item1.Createtime })
            })

            that.totalExtensionTime = []
            response.data.Delaylist.filter((item1, i1) => {
              that.totalExtensionTime.push({ BomsnName: item1.BomsnName, SaletypeName: item1.SaletypeName,Cardnumber: item1.Cardnumber, Delayvalue: item1.Delayvalue, Adminname: item1.Adminname, Createtime: item1.Createtime })
            })

            that.rechargeRecord = []
            response.data.Paylist.filter((item1, i1) => {
              that.rechargeRecord.push({ Id: item1.Id, Orderid: item1.Orderid, Taocanname: item1.Taocanname, Money: item1.Money, Createtime: item1.Createtime })
            })
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    },
    apieditcustomeravatarurl: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        avatarurl: this.imageUrl
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editcustomeravatarurl, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditcustomerbind: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        cardnumber: that.bindForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editcustomerbind, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.binddialog = false
            that.apigetcustomerinfo()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditcustomerunbind: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editcustomerunbind, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.apigetcustomerinfo()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apieditcustomerdelay: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        glassuserid: that.parentdata.params.userid,
        delaytime: that.delayForm.delaytime,
        delaymoney: that.delayForm.delaymoney
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Editcustomerdelay, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.delaydialog = false
            that.apigetcustomerinfo()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apicheckcardnumber: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        cardnumber: that.bindForm.cardnumber
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_CheckCardnumber, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.bindForm.cardnumber = response.data.Cardnumber
            that.bindForm.jigouname = response.data.Jigouname
            that.bindForm.bomsnName= response.data.BomsnName
            that.bindForm.saletypeName= response.data.SaletypeName
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.avatar-uploader{
    margin-right: 20px;
}
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
/deep/ .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 178px;
    height: 178px;
    display: block;
}
.upload{
    display: flex;
    padding-top: 15px;
}
.tips{
    color:#999;
}
</style>
